import { render, staticRenderFns } from "./FloatingButton.vue?vue&type=template&id=09124124"
import script from "./FloatingButton.vue?vue&type=script&lang=js"
export * from "./FloatingButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports